'use client';

import * as React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useDeleteOffers } from '@/lib/api/offers';

interface BulkDeleteOffersModalProps {
    offerIds: string[];
    storeId: string;
    onClose: () => void;
    onSuccess?: () => void;
}

/**
 * BulkDeleteOffersModal component for confirming bulk deletion of offers
 */
export const BulkDeleteOffersModal = ({ offerIds, storeId, onClose, onSuccess }: BulkDeleteOffersModalProps) => {
    const deleteOffersMutation = useDeleteOffers();

    const handleDelete = async () => {
        await deleteOffersMutation.mutateAsync({ offerIds, storeId });
        onSuccess?.();
        onClose();
    };

    return (
        <AlertDialog open={!!offerIds.length} onOpenChange={onClose}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Delete {offerIds.length} offer(s)?</AlertDialogTitle>
                    <AlertDialogDescription>
                        This action cannot be undone. This will permanently delete the selected offer(s) from your store.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={handleDelete}
                        disabled={deleteOffersMutation.isPending}
                        className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                    >
                        {deleteOffersMutation.isPending ? 'Deleting...' : 'Delete'}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
